var map = {
	"./Acumulado_de_Chuva.png": 81,
	"./Baixa_Umidade.png": 78,
	"./Chuvas_Intensas.png": 70,
	"./Declinio_de_Temperatura.png": 80,
	"./Estiagem.png": 75,
	"./Friagem.png": 73,
	"./Geada.png": 74,
	"./Granizo.png": 69,
	"./Incendios.png": 77,
	"./Neve.png": 79,
	"./Onda_de_Calor.png": 72,
	"./Onda_de_Frio.png": 66,
	"./Onde_de_Calor.png": 173,
	"./Onde_de_Frio.png": 174,
	"./Ressaca.png": 65,
	"./Seca.png": 76,
	"./Tempestade.png": 82,
	"./Tempestade_de_Raios.png": 68,
	"./Tornados.png": 67,
	"./Vendaval.png": 71,
	"./Ventos_Costeiros.png": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;